import { C8Node } from "csi/typings";
import CsiImage from "designSystem/components/image/CsiImage";
import { GridRow, IconButton, OverflowText, Text } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React, { FunctionComponent } from "react";

export interface ActionCardProp {
	/* Whether an image should be displayed - default: true */
	displayImage?: boolean;

	/* icon component */
	icon: React.ReactNode;

	/* iconRes to show toolTip */
	iconRes?: string;

	/* card item id */
	id: string;

	/* image source */
	imageSrc?: string;

	/* indicate if all texts should be on incative state grey[800]. Default is false*/
	inactive?: boolean;

	/* label color */
	labelColor?: string;

	/* label resoruce text */
	labelRes?: string;

	/* image node */
	node?: C8Node;

	/* function to be called when icon button is clicked */
	onIconButtonClick?: (id: string) => void;

	/* text to be displayed after the image */
	text: string;
}

const ActionCard: FunctionComponent<ActionCardProp> = (props) => {
	const {
		text,
		labelColor,
		labelRes,
		onIconButtonClick,
		icon,
		iconRes,
		id,
		inactive = false,
		node,
		displayImage = true,
	} = props;

	return (
		<GridRow
			alignItems="center"
			data-csi-automation={`action-card-${text}`}
			flexWrap="nowrap"
			growChild={displayImage ? 1 : 0}
			spacing={2}
			textAlign="left"
		>
			{displayImage && (
				<CsiImage
					border={STANDARD_BORDER_STYLE}
					borderColor={grey[200]}
					borderRadius={1}
					height={24}
					node={node}
					width={24}
				/>
			)}
			<OverflowText
				color={inactive ? grey[800] : undefined}
				text={text}
			/>
			<Text
				color={inactive ? grey[800] : labelColor}
				fontStyle="italic"
				lineHeight={14}
				res={labelRes}
			/>
			<IconButton
				onClick={() => onIconButtonClick(id)}
				res={iconRes}
				round
				size="small"
			>
				{icon}
			</IconButton>
		</GridRow>
	);
};

export default ActionCard;
